import AsyncStorage from "@react-native-async-storage/async-storage";
import { NeuroDetailsType } from "../constants";
enum Keys {
  URL = "URL",
  STORE = "store",
}

export type Store = {
  user_id: string;
  sub: string;
  password: string;
  given_name: string;
  family_name: string;
  email: string;
  profile_nickname: string;
  profile_dob: string;
  profile_gp_details: string;
  profile_support_network: string;
  profile_support_services: string;
  profile_contacts: string;
  profile_work: string;
  gender: string;
  "custom:circumstances": string;
  profile_university: string;
  profile_course: string;
  rasaContext: string;
  passportId: string;
  passport_strategies: string;
  passport_network: string;
  passport_signs: string;
  passport_triggers: string;
  passport_impact: string;
  passport_aspects: string;
  mh_issues_current: string;
  mh_issues_past: string;
  mh_challenges: string;
  neuro_details: NeuroDetailsType[];
  neuro_diagnosed: string;
  neuro_challenges: string;
  wb_current: string;
  wb_past: string;
  wb_challenges: string;
  disabilty_details: string;
  disabilty_difficulties: string;
  disabilty_challenges: string;
  passport_url:string;
  URL:string;
  assistant_report:string;
  files_keys:string;
  conditions_accepted:string;
};

export type Passport = {
  id: string;
  passport_impact: string;
  passport_strategies: string;
  passport_network: string;
  passport_signs: string;
  passport_triggers: string;
  passport_aspects: string;
  mh_issues_current: string;
  mh_issues_past: string;
  mh_challenges: string;
  neuro_details: NeuroDetailsType[];
  neuro_diagnosed: string;
  neuro_challenges: string;
  wb_current: string;
  wb_past: string;
  wb_challenges: string;
  disabilty_details: string;
  disabilty_difficulties: string;
  disabilty_challenges: string;
  profile_gp_details: string;
  profile_contacts: string;
  profile_support_services: string;
  profile_work: string;
  profile_dob: string;
};

const getStorage = async (): Promise<Partial<Store>> => {
  const raw_storage = await AsyncStorage.getItem(Keys.STORE);
  let storage = {};
  if (raw_storage) storage = JSON.parse(raw_storage);

  return storage;
};

const getValue = async (key: string) => {
  const store = await getStorage();

  if (!store) return undefined;

  const value = store[key as keyof Store];

  return value;
};

const setValue = async (key: string, value: any) => {
  try {
    const storage = await getStorage();

    const data = JSON.stringify({ ...storage, [key]: value });

    const res = await AsyncStorage.setItem(Keys.STORE, data);

    return true;
  } catch (error) {
    return false;
  }
};

export const Storage = {
  getStorage,
  setValue,
  getValue,
  Keys,
};
